import { IntegrationEventType } from '../../../../api/generated/data-contracts';

export const getEventIconFromEnum = (type: IntegrationEventType) => {
    switch (type) {
        case 'Project': {
            return 'IssueTracking';
        }
        case 'Task': {
            return 'StackedBarChart';
        }
        case 'Assignment': {
            return 'Assign';
        }
        case 'Actuals': {
            return 'Timer';
        }
        case 'ResourcesInbound': {
            return 'Contact';
        }
        case 'TeamPlannerAllocations': {
            return 'Calendar';
        }
        case 'TeamPlannerProjects': {
            return 'IssueTracking';
        }
        case 'ProjectTeam': {
            return 'Group';
        }
        case 'Calendar': {
            return 'Calendar';
        }
        default:
            return 'Error';
    }
};
